import HelperMixin from '../../Shared/HelperMixin.vue';

// Audit P1 #10 — Super-admin CRUD over CommissionRules (the platform's
// commission-rate dial). Wired to api/admin/CommissionRules via DataService.
// Resolution priority is most-specific-wins (category > driverType > tier);
// a row with NULL on a dimension is a wildcard. Delete is a soft-delete
// (server sets Status=9) — the list only shows active rules.
export default {
    name: 'CommissionRules',
    mixins: [HelperMixin],

    async created() {
        this.loginDetails = await this.CheckLoginStatus();
        if (!this.requireUserType([1])) return; // super-admin only
        await this.LoadCategories();
        await this.Load();
    },

    data() {
        return {
            Items: [],
            Categories: [],
            ShowForm: false,
            EditingId: null,
            Form: {
                TripCategoryId: null,
                DriverType: null,
                TripCountTier: null,
                CommissionPercent: null,
            },
            Saving: false,
            Error: '',
        };
    },

    methods: {
        DriverTypeLabel(t) {
            if (t === 1) return 'موظف (رفيق)';
            if (t === 2) return 'مستقل';
            return 'الكل';
        },
        TierLabel(t) {
            if (t === 1) return 'ضمن الباقة';
            if (t === 2) return 'تجاوز الباقة';
            return 'الكل';
        },
        // The category field used to be a raw number input, so setting a
        // per-category commission meant knowing the category ID by heart.
        // Load the real categories and render a named dropdown instead.
        async LoadCategories() {
            try {
                const res = await this.$http.GetTripCategories();
                // GET api/admin/Trips/Categories answers { info: [...] } —
                // the other shapes are kept as a defensive fallback.
                const d = res && res.data;
                const raw = Array.isArray(d) ? d : (d && (d.info || d.Info || d.items)) || [];
                this.Categories = raw
                    .map(c => ({ id: c.id != null ? c.id : c.Id, name: c.name || c.Name || ('#' + (c.id != null ? c.id : c.Id)) }))
                    .filter(c => c.id != null);
            } catch (e) {
                // Non-fatal: the rest of the page (and the "كل الفئات" wildcard)
                // still works without the category list.
                this.Categories = [];
            }
        },
        CategoryLabel(id) {
            if (id == null) return 'الكل';
            const hit = this.Categories.find(c => Number(c.id) === Number(id));
            return hit ? hit.name : ('#' + id);
        },
        async Load() {
            this.$blockUI.Start();
            try {
                const res = await this.$http.GetCommissionRules();
                this.Items = Array.isArray(res.data) ? res.data : (res.data.items || []);
            } catch (e) {
                this.Items = [];
            } finally {
                this.$blockUI.Stop();
            }
        },
        OpenAdd() {
            this.EditingId = null;
            this.Form = { TripCategoryId: null, DriverType: null, TripCountTier: null, CommissionPercent: null };
            this.Error = '';
            this.ShowForm = true;
        },
        OpenEdit(it) {
            this.EditingId = it.id;
            this.Form = {
                TripCategoryId: it.tripCategoryId != null ? it.tripCategoryId : null,
                DriverType: it.driverType != null ? it.driverType : null,
                TripCountTier: it.tripCountTier != null ? it.tripCountTier : null,
                CommissionPercent: it.commissionPercent,
            };
            this.Error = '';
            this.ShowForm = true;
        },
        CloseForm() {
            this.ShowForm = false;
            this.Error = '';
        },
        // Normalise the empty-string from <select>/<input> back to null so the
        // server treats it as a wildcard, and coerce numerics.
        Normalised() {
            const n = (v) => (v === '' || v === null || v === undefined ? null : Number(v));
            return {
                TripCategoryId: n(this.Form.TripCategoryId),
                DriverType: n(this.Form.DriverType),
                TripCountTier: n(this.Form.TripCountTier),
                CommissionPercent: n(this.Form.CommissionPercent),
            };
        },
        async Save() {
            const body = this.Normalised();
            if (body.CommissionPercent === null || body.CommissionPercent < 0 || body.CommissionPercent > 100) {
                this.Error = 'النسبة يجب أن تكون بين 0 و 100';
                return;
            }
            this.Saving = true;
            this.Error = '';
            try {
                if (this.EditingId) {
                    await this.$http.UpdateCommissionRule(this.EditingId, body);
                } else {
                    await this.$http.CreateCommissionRule(body);
                }
                this.ShowForm = false;
                await this.Load();
            } catch (e) {
                this.Error = (e && e.response && e.response.data && (e.response.data.Message || e.response.data.Code)) || 'تعذّر الحفظ';
            } finally {
                this.Saving = false;
            }
        },
        async Remove(it) {
            if (!window.confirm(`حذف/إخفاء قاعدة العمولة رقم ${it.id}؟`)) return;
            try {
                await this.$http.DeleteCommissionRule(it.id);
                await this.Load();
            } catch (e) {
                alert((e && e.response && e.response.data && e.response.data.Code) || 'تعذّر الحذف');
            }
        }
    }
};
